<template>
    <el-drawer v-model="optionparam.view" size="70%" direction="rtl" title="余额记录" :before-close="handleClose">
        <el-empty description="暂无数据" v-if="walletlist.length==0" />
        <div class="ttl-goods-list" @scroll="handleScroll($event)" v-loading="LoadingObj" v-if="walletlist.length > 0">
            <div class="TTL-table top20">
                <el-table :data="walletlist" stripe="true" empty-text="">
                    <el-table-column label="消费名称" align="center">
                        <template #default="scope">
                            <span>{{scope.row.typename}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="期初金额" align="center">
                        <template #default="scope">
                            <span>{{scope.row.begin_price}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="收入/指出金额" align="center">
                        <template #default="scope">
                            <span>{{scope.row.income==0 ? scope.row.price : '-'+scope.row.price}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="期末结余金额" align="center">
                        <template #default="scope">
                            <span>{{scope.row.end_price}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="关联微信支付单号" align="center">
                        <template #default="scope">
                            <span>{{scope.row.transaction_id}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作时间" align="center">
                        <template #default="scope">
                            <span>{{scope.row.inputtime}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import INTERFACE_MODEL_MEMBER from '@/Interface/Es/member';

export default {
    props:['view','memberid'],
    components:{

    },
    data() {
        return {
            LoadingObj:false,  //loading对象   
            optionparam: {
                view:false,
                memberid:'',
                minid:0,
                maxid:0,
                lastid:0,
                p:0,
                rollpage:10,
            },
            isloading:false,
            isfinish:false,
            walletlist:[],
        }
    },
    
    watch: {
        view(val) {
            if(val) {
                this.isfinish=false;
                this.optionparam.view=true;
                this.optionparam.memberid=this.memberid;
                this.optionparam.minid=0;
                this.optionparam.maxid=0;
                this.optionparam.lastid=0;
                this.optionparam.p=0;
                this.walletlist=[];
                this.GetList();
            }
        }
    },

    methods: {

        //关闭窗口
        handleClose() {
            this.optionparam.view=false;
            this.$emit('finish',{type:'close'});
        },

        //查看关注商品信息
        GetList() {
            if(this.isfinish) return true; //数据已经滚动完成
            if(this.isloading) return false;
            this.isloading=true;

            this.optionparam.p++;
            this.optionparam.lastid=this.walletlist.length==0 ? 0 : this.walletlist[this.walletlist.length-1].id;
            this.LoadingObj=true;
            INTERFACE_MODEL_MEMBER.GET_MEMBER_BALANCE_LIST(this.optionparam).then((res) => {
                 this.LoadingObj=false;
                 this.isloading=false;
                 if(res.status > 0) return false;
                 if(res.data.list.length==0) {this.isfinish=true;return false;}
                 if(res.data.minid > 0) this.optionparam.minid=res.data.minid;
                 if(res.data.maxid > 0) this.optionparam.maxid=res.data.maxid;
                 for(var i=0;i < res.data.list.length;i++) this.walletlist.push(res.data.list[i]);
            });
        },  


        //滚动触发操作
        handleScroll(event) {
            const{ scrollTop, scrollHeight, clientHeight }=event.target;
            //检查是否滚动到底部
            const isBottom = scrollHeight - (scrollTop + clientHeight) < 100; // 这里的1是一个阈值，可以根据需要调整
            if(isBottom) {
                this.GetList();
            }
        },

    },
}
</script>
<style scoped>
.ttl-goods-list {display: inline-block;width:100%;height:100%;overflow-y:auto;}
.ttl-goods-infos {display: inline-flex;align-items: center;width:100%;font-size:0;padding:25px 0;border-bottom:1px solid #F0F2F5;}
.ttl-goods-infos .el-image {display: inline-block;width:50px;height:50px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info {display:inline-block;width:calc(100% - 50px - 20px);}
.ttl-attention {display: inline-flex;align-items: center;width:100%;font-size:13px;position:relative;}
.ttl-goods-name {font-size:13px;}
.ttl-goods-phone {font-size:13px;position:absolute;right:0;color:#333333;}
.ttl-goods-iscompany {font-size:12px;color:#999999;margin-top:5px;}
::-webkit-scrollbar {width:0;}
</style>